export default "__VITE_ASSET__BPBTCbnw__"